(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wondiko-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function table(text) {
      text = String(text || '').replace(/^\uFEFF/, '');
      if (!text.trim()) return [];
      const header = text.split(/\r\n|\r|\n/, 1)[0];
      const delimiter = header.includes('\t') ? '\t' : ',';
      const rows = [];
      let row = [], cell = '', quoted = false, closed = false;
      const finishRow = () => {
        row.push(cell);
        if (row.some(value => value.trim() !== '')) rows.push(row);
        row = []; cell = ''; closed = false;
      };
      for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (quoted) {
          if (char === '"') {
            if (text[i + 1] === '"') { cell += '"'; i++; }
            else { quoted = false; closed = true; }
          } else cell += char;
        } else if (char === delimiter) { row.push(cell); cell = ''; closed = false; }
        else if (char === '\r' || char === '\n') {
          if (char === '\r' && text[i + 1] === '\n') i++;
          finishRow();
        } else if (char === '"' && cell === '' && !closed) quoted = true;
        else if (closed && char.trim()) throw new Error('Unexpected text after a closing quote.');
        else if (!closed) cell += char;
      }
      if (quoted) throw new Error('Unclosed quotation mark in the import.');
      if (cell || row.length || closed) finishRow();
      return rows;
    }
    function parse(text) {
      const rows = table(text);
      if (!rows.length) return [];
      const headers = rows.shift().map(value => value.trim().toLowerCase());
      if (['author', 'rating'].some(key => !headers.includes(key))) throw new Error('Import impossible : la première ligne doit contenir author et rating. Utilisez le modèle CSV ou copiez votre tableau avec ses en-têtes.');
      if (new Set(headers).size !== headers.length || headers.includes('')) throw new Error('Empty or duplicate column headers.');
      return rows.map((row, index) => {
        if (row.length > headers.length) throw new Error('Too many columns on row ' + (index + 2) + '. Check quotation marks.');
        const result = Object.create(null);
        headers.forEach((key, i) => { result[key] = row[i] || ''; });
        return result;
      });
    }
    function validDate(value) {
      if (!value) return true;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
      const date = new Date(value + 'T00:00:00Z');
      return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
    }
    function safePhoto(value) {
      try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password; }
      catch (_) { return false; }
    }
    function fingerprint(review) {
      return JSON.stringify([review.author.trim(), review.rating, review.title.trim(), review.body.trim(), review.date || '']);
    }
    function normalise(text, handle) {
      const errors = [], reviews = [], seen = new Set();
      let records;
      try { records = parse(text); }
      catch (error) { return { reviews, errors: [error.message] }; }
      records.forEach((row, index) => {
        const value = key => String(row[key] || '').trim();
        if (value('product_handle') && value('product_handle') !== handle) return;
        const author = value('author'), body = value('body'), rating = value('rating'), date = value('date');
        if (!author || !/^[1-5]$/.test(rating) || !validDate(date)) {
          errors.push('Row ' + (index + 2) + ': author required, rating must be 1–5, date must be a real YYYY-MM-DD date.');
          return;
        }
        const photoValues = value('photo_urls').split('|').map(url => url.trim()).filter(Boolean);
        const photos = [...new Set(photoValues.filter(safePhoto))].slice(0, 5);
        if (photos.length !== photoValues.length) errors.push('Row ' + (index + 2) + ': invalid, duplicate or extra photos omitted (HTTPS only, maximum 5).');
        const review = { id: value('id'), author, rating: Number(rating), body, title: value('title'), date, photos, verified: value('verified').toLowerCase() === 'true' };
        review.id = review.id || fingerprint(review);
        if (seen.has(review.id)) { errors.push('Row ' + (index + 2) + ': duplicate review ID omitted.'); return; }
        seen.add(review.id); reviews.push(review);
      });
      return { reviews, errors };
    }
    function relativeDate(value, locale = 'fr', now = new Date()) {
      if (!value || !validDate(value)) return '';
      const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
      const days = Math.round((Date.parse(value + 'T00:00:00Z') - today) / 86400000);
      const unit = Math.abs(days) < 30 ? 'day' : 'month';
      const amount = unit === 'day' ? days : Math.trunc(days / 30);
      return new Intl.RelativeTimeFormat(locale, {numeric: days === 0 ? 'auto' : 'always'}).format(amount, unit);
    }
    function compareReviews(a, b, sorting) {
      const aEmpty = !a.body.trim(), bEmpty = !b.body.trim();
      if (aEmpty !== bEmpty) return Number(aEmpty) - Number(bEmpty);
      if (sorting === 'highest') return b.rating - a.rating || a.index - b.index;
      if (sorting === 'lowest') return a.rating - b.rating || a.index - b.index;
      if (sorting === 'newest') return (b.date || '').localeCompare(a.date || '') || a.index - b.index;
      return Number(Boolean(b.photos.length)) - Number(Boolean(a.photos.length)) || a.index - b.index;
    }
    function pageBounds(total, requestedPage, pageSize) {
      const pageCount = Math.ceil(total / pageSize);
      const page = Math.min(Math.max(1, requestedPage), Math.max(1, pageCount));
      const start = (page - 1) * pageSize;
      return {page, pageCount, start, end:Math.min(start + pageSize, total)};
    }
    function pageNumbers(page, pageCount) {
      if (pageCount <= 1) return [];
      const first = Math.max(1, Math.min(page - 1, pageCount - 2));
      const numbers = [];
      for (let number = first; number <= Math.min(pageCount, first + 2); number++) numbers.push(number);
      return numbers;
    }
    window.WondikoReviewParser = { parse, normalise, relativeDate, compareReviews, pageBounds, pageNumbers };
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const handle = root.dataset.productHandle;
      const list = root.querySelector('[data-kr-list]');
      const dialog = root.querySelector('[data-kr-dialog]');
      const dialogImage = root.querySelector('[data-kr-dialog-image]');
      const pagination = root.querySelector('[data-kr-pagination]');
      const controller = new AbortController();
      root.krController = controller;
      const signal = controller.signal;
      const all = [], ids = new Set(), messages = [];
      const pageSize = Math.max(1, Math.min(30, Number(root.dataset.pageSize) || 7));
      let page = 1, sorting = 'featured', opener;
      const text = (key, values) => Object.entries(values || {}).reduce((result, pair) => result.split('[' + pair[0] + ']').join(pair[1]), root.dataset[key] || '');
      const create = (tag, className, value) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (value !== undefined) node.textContent = value;
        return node;
      };
      function starNode(rating) {
        const node = create('span', 'kr-stars');
        node.setAttribute('aria-label', text('ratingLabel', { rating }));
        const base = create('span', '', '★★★★★'), fill = create('span', '', '★★★★★');
        base.setAttribute('aria-hidden', 'true'); fill.setAttribute('aria-hidden', 'true');
        fill.style.width = (rating * 20) + '%'; node.append(base, fill); return node;
      }
      function card(review) {
        const element = create('article', 'kr-card');
        element.append(starNode(review.rating));
        if (review.title) element.append(create('h3', '', review.title));
        if (review.body) element.append(create('blockquote', '', review.body));
        if (review.photos.length) {
          const photos = create('div', 'kr-photos');
          review.photos.forEach(src => {
            const button = create('button', 'kr-photo');
            button.type = 'button'; button.dataset.krPhoto = ''; button.dataset.src = src;
            button.dataset.alt = text('photoLabel', { author: review.author });
            button.setAttribute('aria-label', button.dataset.alt);
            const image = create('img'); image.src = src; image.alt = button.dataset.alt; image.loading = 'lazy'; image.width = 480; image.height = 360;
            button.append(image); photos.append(button);
          });
          element.append(photos);
        }
        const footer = create('footer');
        const words = review.author.trim().split(/\s+/);
        const initials = (words[0]?.[0] || '') + (words.length > 1 ? words[words.length - 1][0] : '');
        const avatar = create('span', 'kr-avatar' + (review.verified ? ' kr-avatar--verified' : ''), initials.toUpperCase());
        avatar.setAttribute('aria-hidden', 'true');
        const identity = create('span', 'kr-identity');
        identity.append(create('span', 'kr-author', review.author));
        if (review.verified) identity.append(create('span', 'kr-verified', text('verified')));
        footer.append(avatar, identity);
        element.append(footer); return element;
      }
      function appendDate(review) {
        if (!review.date || root.dataset.showDates === 'false') return;
        const locale = document.documentElement.lang || 'en';
        const date = create('time', '', relativeDate(review.date, locale));
        date.title = new Date(review.date + 'T00:00:00Z').toLocaleDateString(locale, {year:'numeric', month:'long', day:'numeric', timeZone:'UTC'});
        date.dateTime = review.date; review.el.querySelector('footer').append(date);
      }
      function accept(review) {
        if (ids.has(review.id)) {
          if (review.el) review.el.remove();
          messages.push('A duplicate review was omitted.');
          return false;
        }
        ids.add(review.id);
        review.index = all.length;
        if (review.el) appendDate(review);
        all.push(review); return true;
      }
      list.querySelectorAll('[data-kr-review]').forEach(element => {
        const review = {
          id: element.dataset.id, author: element.querySelector('.kr-author').textContent.trim(),
          body: element.querySelector('blockquote')?.textContent.trim() || '', title: element.querySelector('h3')?.textContent || '',
          rating: Number(element.dataset.rating), date: validDate(element.dataset.date) ? element.dataset.date : '',
          photos: [...element.querySelectorAll('[data-kr-photo]')].map(photo => photo.dataset.src),
          verified: element.dataset.verified === 'true', el: element
        };
        review.id = review.id || fingerprint(review);
        accept(review);
      });
      function summary() {
        const count = all.length;
        const average = count ? all.reduce((sum, review) => sum + review.rating, 0) / count : 0;
        root.querySelector('[data-kr-average]').textContent = average.toFixed(1);
        root.querySelector('[data-kr-average-fill]').style.width = (average * 20) + '%';
        root.querySelector('[data-kr-count]').textContent = text(count === 1 ? 'one' : 'many', {count});
        root.querySelector('[data-kr-overview]').hidden = !count;
        const sortToggle = root.querySelector('[data-kr-toggle]');
        sortToggle.hidden = !count;
        if (!count) {
          root.querySelector('[data-kr-controls]').hidden = true;
          sortToggle.setAttribute('aria-expanded', 'false');
        }
        root.querySelector('[data-kr-empty]').hidden = !!count;
        const detail = {sectionId:root.dataset.sectionId, productHandle:handle, count, average, starColor:getComputedStyle(root).getPropertyValue('--kr-star-color').trim(), starMask:getComputedStyle(root).getPropertyValue('--kr-star-mask').trim()};
        window.wondikoReviewSummaries = window.wondikoReviewSummaries || {};
        window.wondikoReviewSummaries[handle] = detail;
        document.dispatchEvent(new CustomEvent('wondiko:reviews-updated', {detail}));
      }
      function drawPagination(pageCount) {
        pagination.replaceChildren();
        pagination.hidden = pageCount <= 1;
        if (pageCount <= 1) return;
        const button = (label, target, ariaLabel, current = false) => {
          const element = create('button', '', label);
          element.type = 'button'; element.dataset.krPage = String(target);
          element.setAttribute('aria-label', ariaLabel);
          if (current) element.setAttribute('aria-current', 'page');
          element.disabled = target < 1 || target > pageCount;
          pagination.append(element);
        };
        button('‹', page - 1, root.dataset.prevLabel);
        pageNumbers(page, pageCount).forEach(number => button(String(number), number, text('pageLabel', {page:number}), number === page));
        button('›', page + 1, root.dataset.nextLabel);
      }
      function draw() {
        const filtered = [...all];
        filtered.sort((a, b) => compareReviews(a, b, sorting));
        const bounds = pageBounds(filtered.length, page, pageSize);
        page = bounds.page;
        const {pageCount, start, end} = bounds;
        list.querySelectorAll('.kr-card').forEach(element => {
          if (element.hasAttribute('data-kr-review')) element.hidden = true;
          else element.remove();
        });
        filtered.slice(start, end).forEach(review => {
          if (!review.el) {
            review.el = card(review);
            appendDate(review);
          }
          review.el.hidden = false;
          list.append(review.el);
        });
        drawPagination(pageCount);
        const results = root.querySelector('[data-kr-result-count]');
        results.hidden = !filtered.length;
        results.textContent = filtered.length ? text('results', {shown:(start + 1) + '–' + end, total:filtered.length}) : '';
      }
      function report() {
        const target = root.querySelector('[data-kr-errors]');
        if (!target) return;
        target.hidden = !messages.length;
        target.textContent = messages.slice(0, 20).join('\n') + (messages.length > 20 ? '\n… ' + (messages.length - 20) + ' more issues.' : '');
      }
      function add(source) {
        const result = normalise(source, handle);
        messages.push(...result.errors);
        let added = 0;
        result.reviews.forEach(review => { if (accept(review)) added++; });
        if (source.trim()) messages.push('Import: ' + added + ' additional reviews for this product.');
        summary(); draw(); report();
      }
      root.querySelector('[data-kr-sort]').addEventListener('change', event => { sorting = event.target.value; page = 1; draw(); }, {signal});
      pagination.addEventListener('click', event => {
        const button = event.target.closest('button[data-kr-page]');
        if (!button || button.disabled) return;
        const target = Number(button.dataset.krPage);
        if (target === page) return;
        page = target; draw();
        const first = list.querySelector('.kr-card:not([hidden])');
        if (first) { list.scrollIntoView({block:'start'}); first.tabIndex = -1; first.focus({preventScroll:true}); }
      }, {signal});
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-kr-photo]');
        if (!button) return;
        opener = button; dialogImage.src = button.dataset.src; dialogImage.alt = button.dataset.alt || '';
        dialog.showModal();
      }, {signal});
      root.querySelector('[data-kr-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      }, {signal});
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({preventScroll:true}); }, {signal});
      const formDialog = root.querySelector('[data-kr-form-dialog]');
      const writeButton = root.querySelector('[data-kr-write]');
      writeButton.addEventListener('click', () => formDialog.showModal(), {signal});
      root.querySelector('[data-kr-form-close]').addEventListener('click', () => formDialog.close(), {signal});
      formDialog.addEventListener('close', () => writeButton.focus({preventScroll:true}), {signal});
      root.querySelector('[data-kr-toggle]').addEventListener('click', event => {
        const button = event.currentTarget, controls = root.querySelector('[data-kr-controls]');
        controls.hidden = !controls.hidden;
        button.setAttribute('aria-expanded', String(!controls.hidden));
      }, {signal});
      formDialog.querySelectorAll('input[type=radio]').forEach(input => {
        input.addEventListener('change', () => {
          formDialog.querySelectorAll('.kr-rating-input label').forEach(label => label.classList.toggle('is-selected', Number(label.querySelector('input').value) <= Number(input.value)));
        }, {signal});
      });
      if (formDialog.querySelector('[data-kr-form-result]') && location.hash === '#' + formDialog.querySelector('form').id) formDialog.showModal();
      add(root.querySelector('[data-kr-source]').value);
      const csvURL = root.querySelector('[data-kr-url]').textContent.trim();
      if (csvURL) {
        if (!safePhoto(csvURL)) { messages.push('CSV URL must use HTTPS.'); report(); }
        else {
          const fetchController = new AbortController();
          signal.addEventListener('abort', () => fetchController.abort(), {once:true});
          const timeout = setTimeout(() => fetchController.abort(), 15000);
          fetch(csvURL, {signal:fetchController.signal, credentials:'omit'}).then(response => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          }).then(source => { if (root.isConnected) add(source); }).catch(error => {
            if (root.isConnected) { messages.push('CSV could not load. Use a direct public CSV URL with cross-origin access, or paste the spreadsheet instead.'); report(); }
          }).finally(() => clearTimeout(timeout));
        }
      }
    }
    document.querySelectorAll('[data-wondiko-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wondiko-reviews]').forEach(init));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-wondiko-reviews]').forEach(root => {
      root.krController?.abort();
      if (window.wondikoReviewSummaries) delete window.wondikoReviewSummaries[root.dataset.productHandle];
    }));
    document.addEventListener('shopify:block:select', event => {
      const card = event.target.closest?.('.kr-card');
      if (card) { card.hidden = false; card.scrollIntoView({block:'center'}); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wondiko-five-reasons"] && !Shopify.designMode) return;
  try {
    
(function () {
  function carryCampaign(root) {
    const incoming = new URLSearchParams(window.location.search);
    root.querySelectorAll('.kl-five [data-kl-product]').forEach(function(link) {
      const target = new URL(link.href, window.location.origin);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'].forEach(function(key) {
        const value = incoming.get(key);
        if (value) target.searchParams.set(key, value);
      });
      link.href = target.href;
    });
  }
  carryCampaign(document);
  document.addEventListener('shopify:section:load', function(event) { carryCampaign(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wondiko-listicle-editor"] && !Shopify.designMode) return;
  try {
    
(function () {
  function carryCampaign(root) {
    const incoming = new URLSearchParams(window.location.search);
    root.querySelectorAll('.kl-five [data-kl-product]').forEach(function(link) {
      const target = new URL(link.href, window.location.origin);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'].forEach(function(key) {
        const value = incoming.get(key);
        if (value) target.searchParams.set(key, value);
      });
      link.href = target.href;
    });
  }
  carryCampaign(document);
  document.addEventListener('shopify:section:load', function(event) { carryCampaign(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wondiko-listicle-sticky"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wondiko-listicle-sticky')) {
  customElements.define('wondiko-listicle-sticky', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const mode = this.dataset.displayMode;
        const threshold = Number(this.dataset.displayThreshold || 0);
        const available = document.documentElement.scrollHeight - window.innerHeight;
        const visible = mode === 'always' || (mode === 'after_pixels' ? window.scrollY >= threshold : available > 0 && window.scrollY / available * 100 >= threshold);
        this.dataset.visible = String(visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
      };
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      window.addEventListener('load', this.update);
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
      window.removeEventListener('load', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wondiko-relance-offre"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-wvo-bundle]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const href = link.getAttribute('href');
  if (!href?.startsWith('#')) return;
  const target = document.getElementById(href.slice(1));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: 'center'
  });
  const choice = target.querySelector('input[type="radio"]:checked') || target.querySelector('input[type="radio"]');
  choice?.focus({ preventScroll: true });
});

  } catch(e) { console.error(e); }
})();
})();
